module.exports = __webpack_public_path__ + "static/media/registrationSuccess.c8ed3395.svg";